import { render } from "./BookingFormComponent.vue?vue&type=template&id=8b3d5fc4&scoped=true"
import script from "./BookingFormComponent.vue?vue&type=script&lang=ts"
export * from "./BookingFormComponent.vue?vue&type=script&lang=ts"

import "./BookingFormComponent.vue?vue&type=style&index=0&id=8b3d5fc4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b3d5fc4"

export default script